import {
  FaDiagramProject,
  FaEnvelope,
  FaGithub,
  FaHouse,
  FaLinkedinIn,
  FaRenren,
  FaUser,
} from "react-icons/fa6";
import {
  codeBook,
  cineMate,
  dash,
  shopping,
  article,
  kechie,
} from "../assets";

export const Socials = [

  {
    id: `linkedin-${Date.now()}`,
    Icon: FaLinkedinIn,
    uri: "https://www.linkedin.com/in/maria-sawaby-nazehat/",
    color: "#0072b1",
  },
  {
    id: `github-${Date.now()}`,
    Icon: FaGithub,
    uri: "https://github.com/sawaby",
    color: "#fff",
  },

];

export const Menus = [
  {
    id: `home-${Date.now()}`,
    Icon: FaHouse,
    uri: "#home",
    name: "Home",
  },
  {
    id: `about-${Date.now()}`,
    Icon: FaUser,
    uri: "#about",
    name: "About",
  },
  {
    id: `skills-${Date.now()}`,
    Icon: FaRenren,
    uri: "#skills",
    name: "Skills",
  },
  {
    id: `projects-${Date.now()}`,
    Icon: FaDiagramProject,
    uri: "#projects",
    name: "Projects",
  },
  {
    id: `contact-${Date.now()}`,
    Icon: FaEnvelope,
    uri: "#contact",
    name: "Contact",
  },
];

export const ProjectsData = [
  {
    id: `codeBook-${Date.now()}`,
    title: "CodeBook",
    description: "The Ultimate Ebook Store. React, e-commerce website",
    image: codeBook,
    tag: ["All", "React"],
    gitUrl: "https://github.com/sawaby/CodeBook",
    previewUrl: "http://codebook-m.netlify.app",
  },
  {
    id: `cineMate-${Date.now()}`,
    title: "CineMate",
      description: "Displays list of updated movies using TMDB API",
      image: cineMate,
      tag: ["All", "React"],
      gitUrl: "https://github.com/sawaby/cinemate",
      previewUrl: "http://cinemate-m.netlify.app",
  },
  {
    id: `shopping-${Date.now()}`,
    title: "Shopping Cart",
      description: "REACT Shopping cart using context and reducer.",
      image: shopping,
      tag: ["All", "React"],
      gitUrl: "https://github.com/sawaby/shopmatecr",
      previewUrl: "http://shopmatecr-m.netlify.app",
  },
  {
    id: `article-${Date.now()}`,
    title: "Article Blog",
      description: "Login, create or remove articles. Using Firebase.",
      image: article,
      tag: ["All", "React"],
      gitUrl: "https://github.com/sawaby/ArticleBlog",
      previewUrl: "http://articleblog-m.netlify.app/",
  },
  {
    id: `dash-${Date.now()}`,
    title: "Admin Dashboard",
      description: "Admin dashboard, with ability to add tasks and reports. as well as kanban with task drag and drop ability.",
      image: dash,
      tag: ["All", "React"],
      gitUrl: "https://github.com/sawaby/mydashboard",
      previewUrl: "http://mydashboard-phi.vercel.app/",
  },
  {
    id: `kechie-${Date.now()}`,
    title: "Kechie ERP Software",
      description: "A fully scalable cloud ERP system. Been part of it.",
      image: kechie,
      tag: ["All", "Progress"],
      gitUrl: "/",
      previewUrl: "https://www.myofficeapps.com/",
  },
];
